import { render, staticRenderFns } from "./publishingPlatformModal.vue?vue&type=template&id=7632b506&scoped=true"
import script from "./publishingPlatformModal.vue?vue&type=script&lang=js"
export * from "./publishingPlatformModal.vue?vue&type=script&lang=js"
import style0 from "./publishingPlatformModal.vue?vue&type=style&index=0&id=7632b506&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7632b506",
  null
  
)

export default component.exports